import { Injectable } from "@angular/core";

type FormStateType = 'CFS' | 'HUB' | 'CSR' | 'ENQUIRY';

@Injectable({ providedIn: 'root' })
export class SharedFormService {
  private cfsFormState: any;
  private hubFormState: any;
  private csrFormState: any;
  private enquiryFormState: any;
  private flags: { [key: string]: boolean } = {};

  setFormState(type: FormStateType, data: any) {
    if (type === 'CFS') {
      this.cfsFormState = data;
    } else if (type === 'CSR') {
      this.csrFormState = data;
    } else if (type === 'ENQUIRY') {
      this.enquiryFormState = data;
    } else {
      this.hubFormState = data;
    }
  }

  getFormState(type: FormStateType) {
    if (type === 'CFS') return this.cfsFormState;
    if (type === 'CSR') return this.csrFormState;
    if (type === 'ENQUIRY') return this.enquiryFormState;
    return this.hubFormState;
  }

  clearFormState(type: FormStateType) {
    if (type === 'CFS') {
      this.cfsFormState = null;
    } else if (type === 'CSR') {
      this.csrFormState = null;
    } else if (type === 'ENQUIRY') {
      this.enquiryFormState = null;
    } else {
      this.hubFormState = null;
    }
  }
  setFlag(key: string, value: boolean): void {
    this.flags[key] = value;
  }

  getFlag(key: string): boolean {
    return this.flags[key] || false;
  }

  clearFlag(key: string): void {
    delete this.flags[key];
  }
}

